export const colors = {
  primary: {
    light: 'cyan-300',
    base: 'cyan-400',
    dark: 'cyan-500'
  },
  text: {
    primary: 'cyan-400',
    secondary: 'cyan-100/70',
    muted: 'cyan-500/40',
    title: {
      primary: 'cyan-300',
      secondary: 'cyan-200'
    }
  },
  background: {
    base: 'gray-900/50',
    surface: 'gray-800/95',
    input: 'gray-900/80'
  },
  border: {
    primary: 'cyan-500/20',
    focus: 'cyan-400/30',
    muted: 'cyan-500/10'
  },
  state: {
    success: 'emerald-400',
    error: 'red-400',
    warning: 'amber-400',
    disabled: 'gray-600'
  }
} 